export default class SimpleMessage {
  constructor(
      subject = "DPMPTSP",
      to= "", //Nomor Whatsapp
      message = ""

  ) {
    this.subject = subject;
    this.to = to;
    this.message = message;
  }

}
